import { useEffect, useState } from "react";
import {
    ButtonLink,
    Card,
    CardBody,
    Col,
    Content,
    Icon,
    LoadingSpinner,
    Row,
    SmallValueBox,
} from "@webtypen/react-components";
import { Page } from "../components";
import { ApiHelper } from "../helpers";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export const DashboardCustomer = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);

    const load = () => {
        setIsLoading(true);

        ApiHelper.request("/api/dashboard/customer")
            .then((response) => {
                setData(response.status === "success" && response.data ? response.data : null);
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setData(null);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <Page title="Dashboard">
            <Content>
                <Row>
                    <Col width={3}>
                        <Card>
                            <CardBody>
                                <SmallValueBox
                                    value={
                                        isLoading ? (
                                            <LoadingSpinner />
                                        ) : data && data.stats && data.stats.contracts_upcoming ? (
                                            data.stats.contracts_upcoming
                                        ) : (
                                            "-"
                                        )
                                    }
                                    label="Anstehende Aufträge"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col width={3}>
                        <Card>
                            <CardBody>
                                <SmallValueBox
                                    value={
                                        isLoading ? (
                                            <LoadingSpinner />
                                        ) : data && data.stats && data.stats.contract_requests_pending ? (
                                            data.stats.contract_requests_pending
                                        ) : (
                                            "-"
                                        )
                                    }
                                    label="Offene Auftragsanfragen"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col width={12} className="mt-2">
                        <ButtonLink to="/contract-request" sm>
                            <Icon icon={faPlus} className="mr-1" />
                            Auftragsanfrage erstellen
                        </ButtonLink>
                    </Col>

                    <Col width={12} className="mt-4">
                        <h3>Neuigkeiten</h3>
                        <i>Aktuell stehen keine Neuigkeiten zu Verfügung ...</i>
                    </Col>
                </Row>
            </Content>
        </Page>
    );
};
